<div class="view-component" *ngIf="insert">
  <div class="content">

        <mat-stepper [linear]="isLinear" #stepper class="stepper" >
          <mat-step [stepControl]="firstFormGroup">
            <form [formGroup]="firstFormGroup">              
              <ng-template matStepLabel>Início da Configuração</ng-template>
              
              <div class="jumbo">
                  <div class="div1">
                      <mat-form-field appearance="outline">
                        <mat-label>Nome da Configuração</mat-label>
                        <input matInput formControlName="nome" required>
                      </mat-form-field>
                      <mat-divider></mat-divider>
                      <div class="more-options">
                        <mat-slide-toggle   [(ngModel)]="multiContext"  [ngModelOptions]="{standalone: true}" (change)="onToggleChange()">Multiplo Contexto
                        </mat-slide-toggle>
                      </div>
                      <mat-divider></mat-divider>
                      <search-input  entityname="Mktpcompanies"  entitydesc="Empresas" [form]="firstFormGroup" controlname="CODECOMPANY" placeholder="Cód. Empresa" columnname="CODECOMPANY" *ngIf="!multiContext">
                      </search-input>
                      <search-input  entityname="Mktplaces"  entitydesc="MarketPlace" [form]="firstFormGroup" controlname="CODEMKTP" placeholder="Market Place" columnname="CODEMKTP">
                      </search-input>
                      <search-input  entityname="Mktptpi"  entitydesc="Mktptpi" [form]="firstFormGroup" controlname="IDTPI" placeholder="Tipo de Configuração" columnname="IDTPI">
                      </search-input>
                  </div>
                  <div fxLayout="row" fxLayoutGap="20px" class="buttonLayout">
                    <button mat-flat-button matStepperPrevious (click)="exit()">Cancelar</button>
                    <button mat-raised-button color="primary" matStepperNext>Avançar</button>
                  </div>
                  
              </div>
            </form>
          </mat-step>
          <mat-step [stepControl]="secondFormGroup" label="+ Configurações">
              <form [formGroup]="secondFormGroup">
                <ng-template matStepLabel>+ Configurações</ng-template>
                
                <div class="jumbo">
                    <div class="div1">
                        
                        <mat-form-field appearance="outline">
                          <mat-label>Ativo</mat-label>
                          <mat-select required formControlName="ativo" #ativo>
                            <mat-option value="S">Sim</mat-option>
                            <mat-option value="N">Não</mat-option>
                          </mat-select>
                        </mat-form-field>

                        <input-button-popup
                            [controle]="secondFormGroup.get('schedule')"
                            label="Agendador" 
                            type='text'
                            icon='alarm'
                            required="true"
                            [component]="cronComponent"
                            (result)="formSubmitted($event)" 
                        >
                        </input-button-popup>
                        
                        <mat-form-field appearance="outline">
                          <mat-label>Ambiente</mat-label>
                          <mat-select required formControlName="ambiente" #ambiente>
                            <mat-option value="1">Produção</mat-option>
                            <mat-option value="2">Homologação</mat-option>
                          </mat-select>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                          <mat-label>Dias de Retenção</mat-label>
                          <input matInput formControlName="diasret" required type="number"  min="0"> 
                          <mat-error *ngIf="secondFormGroup.get('diasret').invalid">Menor valor é 0</mat-error>
                        </mat-form-field>
                        
                    </div>
                    <div fxLayout="row" fxLayoutGap="20px" class="buttonLayout">
                    <button mat-flat-button matStepperPrevious>Voltar</button>
                    <button mat-raised-button color="primary" matStepperNext>Avançar</button>
                    </div>
                    
                </div>
              </form>


          </mat-step>
          <mat-step>
            <ng-template matStepLabel>Finalizado</ng-template>
            <div class="jumbo">
              <div class="div1">
                <details open="true">
                  <summary>Resumo</summary>
                  <div class="lista">
                    <mat-list>
                      <mat-list-item>  <mat-icon mat-list-icon>check</mat-icon> <b>Nome:</b> {{firstFormGroup.get('nome').value}}</mat-list-item>
                      <mat-divider></mat-divider>
                      <mat-list-item>  <mat-icon mat-list-icon>check</mat-icon> <b>Empresa:</b> {{firstFormGroup.get('CODECOMPANY').value}} - {{firstFormGroup.get('CODECOMPANY->NAME').value}}</mat-list-item>
                      <mat-divider></mat-divider>
                      <mat-list-item>  <mat-icon mat-list-icon>check</mat-icon> <b>MarketPlace:</b> {{firstFormGroup.get('CODEMKTP').value}} - {{firstFormGroup.get('CODEMKTP->NAME').value}}</mat-list-item>
                      <mat-divider></mat-divider>
                      <mat-list-item>  <mat-icon mat-list-icon>check</mat-icon> <b>Tipo Configuração:</b> {{firstFormGroup.get('IDTPI').value}} - {{firstFormGroup.get('IDTPI->NAME').value}}</mat-list-item>
                      <mat-divider></mat-divider>
                      <mat-list-item>  <mat-icon mat-list-icon>check</mat-icon> <b>Ativo:</b> {{secondFormGroup.get('ativo').value}} - {{ativo.selected?.viewValue}}</mat-list-item>
                      <mat-divider></mat-divider>
                      <mat-list-item>  <mat-icon mat-list-icon>check</mat-icon> <b>Ambiente:</b> {{secondFormGroup.get('ambiente').value}} - {{ambiente.selected?.viewValue}}</mat-list-item>
                      <mat-divider></mat-divider>
                      <mat-list-item>  <mat-icon mat-list-icon>check</mat-icon> <b>Agendador:</b> {{secondFormGroup.get('schedule').value}}</mat-list-item>
                      <mat-divider></mat-divider>
                      <mat-list-item>  <mat-icon mat-list-icon>check</mat-icon> <b>Dias de Retenção:</b> {{secondFormGroup.get('diasret').value}}</mat-list-item>
                    </mat-list>               
                  </div>
                </details>          
              </div>

              <div fxLayout="row" fxLayoutGap="20px" class="buttonLayout">
                <span><button mat-flat-button matStepperPrevious>Voltar</button></span>
                <span><button mat-raised-button color="primary" (click)="salvar()">Salvar</button></span>
              </div>
            </div>
            
          </mat-step>
        </mat-stepper>
  </div>
</div>
<main-configuracao-view *ngIf="!insert" [id]="firstFormGroup.get('idconf').value">
    <div header>
      {{firstFormGroup.get('nome').value}} - {{firstFormGroup.get('IDTPI').value}} - {{firstFormGroup.get('IDTPI->NAME').value}}
    </div>
    <div class="maincontent" body>
      <mat-grid-list cols="2" rowHeight="70px">
        <form [formGroup]="firstFormGroup">
          <mat-grid-tile>
            <span>
              <mat-form-field appearance="outline">
                <mat-label>Nome da Configuração</mat-label>
                <input matInput formControlName="nome" required>
              </mat-form-field>
            </span>
          </mat-grid-tile>
          <mat-grid-tile>
            <span>
              <search-input  entityname="Mktpcompanies" entitydesc="Empresas" useFormValues="S" [form]="firstFormGroup" controlname="CODECOMPANY" placeholder="Cód. Empresa" columnname="CODECOMPANY">
              </search-input>    
            </span>
          </mat-grid-tile>
          <mat-grid-tile>       
            <span>
              <search-input  entityname="Mktplaces"  entitydesc="MarketPlace" [form]="firstFormGroup" controlname="CODEMKTP" placeholder="Market Place" columnname="CODEMKTP">
              </search-input>          
            </span>
          </mat-grid-tile>
          <mat-grid-tile>
            <span>
              <search-input  entityname="Mktptpi"  entitydesc="Mktptpi" [form]="firstFormGroup" controlname="IDTPI" placeholder="Tipo de Configuração" columnname="IDTPI">
              </search-input>
            </span>
          </mat-grid-tile>
        </form>
        <mat-grid-tile colspan="2">
          <span><mat-divider></mat-divider></span>
        </mat-grid-tile>
        <form [formGroup]="secondFormGroup">
          <mat-grid-tile>
            <span>
              <mat-form-field appearance="outline">
                <mat-label>Ativo</mat-label>
                <mat-select required formControlName="ativo" #ativo>
                  <mat-option value="S">Sim</mat-option>
                  <mat-option value="N">Não</mat-option>
                </mat-select>
              </mat-form-field>
            </span>
          </mat-grid-tile>
          <mat-grid-tile>
            <span>
              <input-button-popup
                            [controle]="secondFormGroup.get('schedule')"
                            label="Agendador" 
                            type='text'
                            icon='alarm'
                            required="true"
                            *ngIf="expression"
                            [component]="cronComponent"
                            (result)="formSubmitted($event)" 
                            [disabled]="saveDisabled"
                        >
               </input-button-popup>
            </span>
          </mat-grid-tile>
          <mat-grid-tile>
            <span>
              <mat-form-field appearance="outline">
                <mat-label>Ambiente</mat-label>
                <mat-select required formControlName="ambiente" #ambiente >
                  <mat-option *ngFor="let item of typeAmbiente" [value]="item.key">item.name</mat-option>
                </mat-select>
              </mat-form-field>
            </span>
          </mat-grid-tile>
          <mat-grid-tile>
            <span>
              <mat-form-field appearance="outline">
                <mat-label>Dias de Retenção</mat-label>
                <input matInput formControlName="diasret" required type="number"  min="0"> 
                <mat-error *ngIf="secondFormGroup.get('diasret').invalid">Menor valor é 0</mat-error>
              </mat-form-field>
            </span>
          </mat-grid-tile>
          <mat-grid-tile colspan="2">
            <span>
              <div  class="buttonLayoutSave" >
                <span><button mat-flat-button (click)="clickEdit()">{{btnName}}</button></span>
                <span><button mat-raised-button type="submit" color="primary" (click)="salvar()" [disabled]="saveDisabled">Salvar</button></span>
              </div>
            </span>
          </mat-grid-tile>
        </form>
        
      </mat-grid-list>
  </div>
  <div second-view class="second-view">
    <app-type-integration-view [idConf]="firstFormGroup.get('idconf').value" [nomeConf]="firstFormGroup.get('nome').value" [codeCompany]="firstFormGroup.get('CODECOMPANY').value" [codeMktp]="firstFormGroup.get('CODEMKTP').value" ></app-type-integration-view>
  </div>
</main-configuracao-view>